import React from "react";
import { createRoot } from 'react-dom/client'
import Routes from "./Routes/Routes";
// import "./index.css";
const root = createRoot(document.getElementById("root"));
root.render(
    <Routes />
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
